import type { Url } from "../../data-model/primitives.js";
import { ParseError } from "../../core/errors.js";

/**
 * Drop a leading paragraph block that duplicates the chapter title. Blocks are
 * the `\n\n`-separated paragraphs produced by `normalizeText`. The comparison is
 * whitespace-normalized; a non-matching first block is left in place. Always
 * returns a re-joined, trimmed string.
 */
export function stripLeadingTitle(content: string, title: string): string {
  const blocks = content.split("\n\n");
  const normalizedTitle = title.replace(/\s+/g, " ").trim();
  if (normalizedTitle.length > 0 && blocks[0]?.replace(/\s+/g, " ").trim() === normalizedTitle) {
    blocks.shift();
  }
  return blocks.join("\n\n").trim();
}

/** Throw {@link ParseError} when a chapter body is empty after normalization. */
export function assertContentNonEmpty(content: string, url: Url): void {
  if (content.length === 0) {
    throw new ParseError("Empty chapter body after normalization", { url });
  }
}
